import axios from 'axios'
import { dropDown } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

/**
 * Reasons a quote can be marked as lost. Maintained in the quote_lost_reason
 * table so the list can be extended without a release.
 */
export const getQuoteLostReasons = async (): Promise<dropDown[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/QuoteLostReason`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return (response.data as any[]).map((reason) => ({
    value: reason.quoteLostReasonId,
    text: reason.name,
  }))
}
